import { PeriodRange } from "@linkfluence/models/date";
import { useImageClusters } from "@radarly/core/insights/use-cases";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { useCurrentWorkspaceId } from "@radarly/core/workspace/use-cases";
import { ClusterFragment } from "@radarly/models/search";

export function useImageClusterWidget(
  fragment: ClusterFragment,
  period: PeriodRange
) {
  const locale = useCurrentUserLocale();
  const project = useCurrentProject();
  const workspaceId = useCurrentWorkspaceId();
  const { loading, data } = useImageClusters(
    workspaceId,
    //@ts-ignore : the id is necessary to get cluster data in a snapshot
    { ...fragment.request.query, id: fragment.request.id },
    period
  );
  return {
    locale,
    project,
    loading,
    data: data || { clusters: [], total: 0 },
  };
}
